import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as shippingActions from "../store/shipping/actions";

const useCheckZip = (label, countryCode = "US") => {
  // const checkZipCache = useRef({})
  const zipChecks = useSelector(
    ({ shipping }) => shipping && shipping.checkZip
  );
  const dispatch = useDispatch();
  const [checking, setChecking] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);

  const checkZipIsValid = async (value) => {
    const pairName = [value, countryCode].join("-");
    try {
      if (value && value.length === 5 && !checking) {
        let checkData;
        if (zipChecks[pairName]) {
          checkData = zipChecks[pairName];
        } else {
          setChecking(true);
          checkData = await dispatch(
            shippingActions.checkZip({ zip: value, country: countryCode })
          );
          setChecking(false);
        }
        if (checkData && checkData === "false") {
          setIsInvalid(true);
          return `LSO does not offer service to that ${label}`;
        } else {
          setIsInvalid(false);
        }
      }
    } catch (error) {
      setChecking(false);
      setIsInvalid(true);
      return `Something went wrong while checking ${label}.`;
    }
  };
  return [checkZipIsValid, checking, isInvalid];
};

export default useCheckZip;
